export default __webpack_public_path__ + "static/media/Astronaut-02.17f01cb0.png";